<!--@description 封装全局促销套餐加入购物车
    @author cc
    @date 2020-3-12
  -->
<template>
  <div>
    <cc-bottom-popup :autoHeight="true" v-bind="$attrs" v-on="$listeners" @subBtn="subBtn">
      <!-- 内容 -->
      <!-- <div class="cart-promot" slot="cart"> -->
      <template slot="header">
        <div class="cart-promot-goods">
          <div
            class="cart-promot-goods-list"
            v-for="(item,index) in promotCartData.goods_list"
            :key="index"
          >
            <div class="cart-promot-goods-list-left">
              <img v-lazy="item.image" />
            </div>
            <div class="cart-promot-goods-list-right">
              <p class="cart-promot-goods-list-right-title">
                <span class="mr5">{{item.general_name}}</span>
                <span>{{item.norms}}</span>
              </p>
              <p>{{'数量：'+item.quantity}}</p>
              <p>{{'￥'+float_change(item.price)}}</p>
            </div>
          </div>
        </div>
      </template>
      <div class="cart-promot-info">
        <p>
          套餐价：
          <span>{{isNaN(promotCartData.jiage)?'':'￥'}}</span>
          <span
            :class="isNaN(promotCartData.jiage)?'f15':'f18'"
          >{{float_change(promotCartData.jiage)}}</span>
        </p>
        <p>
          <span>数量：</span>
          <span class="fr">
            <cc-stepper-new
              :min="promotCartData.step"
              v-model="promotCartData.num"
              :step="promotCartData.step"
              :max="promotCartData.stock"
              :choose="promotCartData.choose"
            ></cc-stepper-new>
          </span>
        </p>
        <p>
          库存：
          <span style="color:#777777;">{{promotCartData.stock}}</span>
        </p>
      </div>
      <!-- </div> -->
    </cc-bottom-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import { Toast, Dialog } from 'vant'
import { addtocartnew } from '@/fetch/common'
import Command from '@/mixins/command'
import { SessionStorage } from '@/utils'

Vue.use(Dialog).use(Toast)
export default {
  mixins: [Command],
  name: 'CcPromotCart',
  props: {
    // 商品数据
    promotCartData: {
      type: Object
    },
    // // 显示隐藏
    NogoodShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  created () {},
  methods: {
    async tocart (res) {
      Toast(res.info.msg)
      // 关闭弹窗
      this.cartGetnum()
      this.$emit('close')
      SessionStorage.setItem('hasNewGoods', '1') // 加入一个标识 通知购物车有新的商品加入，再次进入购物车重新请求
    },
    /**
     * @description 加入购物车确定按键操作
     * @author cc
     * @date 2020-03-13
     */
    async subBtn () {
      // 1. 多批号选择开启需选择多批号购买 1开启 0关闭
      if (this.getLoadSettingStatus.data.is_select_bacth_buy === 1) {
        Toast('多批号暂不支持购买该促销套餐！')
        return false
      }
      let data = {
        for_id: this.promotCartData.id || this.promotCartData.for_id,
        type: 3,
        quantity: this.promotCartData.num,
        remind: 0
      }
      // 2.加入购物车
      let Resone = await addtocartnew(data)
      if (Resone.status === 2) {
        // 2.1商品再次加入购物车是否提醒：
        Dialog.confirm({
          message: Resone.info.msg,
          confirmButtonText: '添加'
        })
          .then(async () => {
            data.remind = 1
            let res = await addtocartnew(data)
            this.tocart(res)
          })
          .catch(() => {
            // 弹窗取消操作
          })
      } else {
        this.tocart(Resone)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cart-promot {
  height: 507px;
  border: 10px 10px 0 0;
  &-goods {
    &-list {
      display: flex;
      flex-direction: row;
      &-left {
        margin-right: 18px;
        img {
          @include wh(60px, 60px);
          border-radius: 4px;
        }
      }
      &-right {
        p {
          margin-bottom: 5px;
          color: #333333;
        }
        p:nth-child(2) {
          font-size: 12px;
        }
        p:nth-child(3) {
          font-size: 12px;
        }
        &-title {
          font-size: 15px;
          @include ell(2);
          padding-right: 0.3rem;
        }
      }
    }
  }
  &-info {
    padding: 0 10px;
    p:nth-child(1) {
      span {
        color: #e91b41;
      }
      span:nth-child(1) {
        font-size: 12px;
      }
      span:nth-child(2) {
        font-size: 18px;
      }
    }
    p {
      margin: 15px 0;
      font-size: 12px;
      color: #333333;
    }
  }
}
</style>
